module.exports = __webpack_public_path__ + "img/hohlsaum_feuerrot_ral3000.0d7f9ae7.jpg";